import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title: 'Želim da zakažem test vožnju',
    subtitle: 'Odaberite',
    submitBtn: 'Rezerviši test vožnju',
    car: {
      title: 'Podatki o vozilu za katerega želite storitev Nissan',
      model: {
        title: 'Odaberite vozilo',
        select: 'Izberite model',
        error: 'Iz seznama izberite model vašega vozila'
      },
      age: {
        title: 'Starost vozila',
        select: 'Izberite letnik vozila'
      },
      vin: {
        title: 'Številka šasije',
        placeholder: 'Primer: VF1BR2....'
      },
      milage: {
        title: 'Število prevoženih kilometrov'
      },
      testDrive: 'Želim izvedeti, ali lahko dobim nadomestno vozilo'
    },
    services: {
      title: 'Vrsta storitve',
      service: {
        title: 'Izberite eno naših storitev',
        select: 'Izberite storitev',
        error: 'Morate izbrati eno od storitev'
      },
      notes: {
        title: 'Moje sporočilo'
      }
    },
    dealer: {
      title: 'Odaberite distributera',
      location: 'Unesite svoju lokaciju',
      workTime: 'Radno vreme',
      address: 'Adresa',
      workDays: {
        monday: 'Ponedeljak',
        tuesday: 'Utorak',
        wednesday: 'Sreda',
        thursday: 'Četvrtak',
        friday: 'Petak',
        saturday: 'Subota',
        sunday: 'Nedelja'
      },
      pickBtn: 'Odaberi svog dilera',
      titleDealer: 'Izbira termina',
      dealer: {
        title: 'Pooblaščeni prodajalec',
        select: 'Izberite pooblaščenega prodajalca',
        error: 'Izberite pooblaščenega prodajalca.'
      },
      date: {
        title: 'Datum'
      },
      time: {
        title: 'Čas',
        select: 'Izberite želeno uro',
        error: 'Izberite željeno uro.',
        helpText: 'Izbrani termin je informativne narave. O razpoložljivem terminu vas bo obvestil izbrani pooblaščeni serviser.'
      }
    },
    user: {
      title: 'Moji podaci',
      gender: {
        title: 'Oslovljavanje',
        select: 'Izaberite',
        error: 'Unos oslovljavanja je obavezan.'
      },
      name: {
        title: 'Ime',
        error: 'Upišite svoje ime.'
      },
      lastName: {
        title: 'Prezime',
        error: 'Upišite prezime.'
      },
      business: {
        title: 'Podjetje'
      },
      email: {
        title: 'E-adresa',
        error: 'Upišite e-mail adresu.'
      },
      address: {
        title: 'Ulica',
        error: 'Upišite naziv ulice.'
      },
      houseNumber: {
        title: 'Broj',
        error: 'Upišite broj.'
      },
      postalCode: {
        title: 'Poštanski broj',
        error: 'Upišite svoj poštanski broj.'
      },
      city: {
        title: 'Grad',
        error: 'Upišite naziv svog grada.'
      },
      phone: {
        title: 'Broj telefona',
        error: 'Upišite telefonski broj bez razmaka.',
        helpText: 'Upišite telefonski broj bez razmaka.'
      }
    },
    gdpr: {
      title: 'Potvrda',
      error: 'Označili ste DA kod najmanje jedne vrste obaveštenja zato vas molimo da odaberete najmanje jedan način obaveštavanja.',
      terms: {
        title: 'Pročitala/Pročitao sam pravne informacije i slažem se sa njima',
        error: 'Za nastavak se morate složiti sa pravnim obaveštanjima.',
        helpText: 'Posredovanjem ličnih podataka dozvoljavam da Renault Nissan Srbija, d.o.o. sam ili preko izabranog ovlašćenog trgovca Nissan upotrebljava lične podatke, navedene u gornjem obrascu, u svrhu sprovođenja probne vožnje u vremenskom periodu potrebnom za izvršenje usluge, odnosno najduže 3 godine.',
        helpText2: 'Vođenje, kontrola i upravljanje bazom podataka ličnosti kao i posredovanje podataka trećim licima precizno određuje Pravilnik ZLP kompanije Renault Nissan Srbija, d.o.o. i Katalog podataka o ličnosti, kojima upravlja Renault Nissan Srbija, d.o.o. Više o opštim informacijama o zaštiti ličnih podataka mogu da pročitam <a href="http://www.nissan.rs/opste-zlp.html" target="_blank">OVDE</a>. U slučaju zloupotrebe mojih podataka mogu da se obratim Renault Nissan Srbiji d.o.o. na e-adresu: <a href="mailto:zlp.nissan@nissan.rs">zlp.nissan@nissan.rs</a>.'
      },
      comply: {
        title: 'Da li želite da vam šaljemo poruke o aktuelnim ponudama i novostima?',
        yes: 'DA',
        no: 'NE',
        error: 'Molimo označite svoj odabir.',
        agree: 'SAGLASNOST ZA OBAVEŠTAVANJE'
      },
      types: {
        title: 'Vrste poruka',
        description: 'Označavanjem donjih kategorija dozvoljavam da Renault Nissan Srbija, d.o.o. i izabrani ovlaščeni distributer Nissan koriste moje podatke za slanje prilagođenih poruka, vezanih za potraživanja iz gornjeg obrasca, kao i da ih čuvaju i obrađuju u skladu sa Politikom o zaštiti podataka o ličnosti (važeći dokument je objavljen <a href="http://www.nissan.rs/opste-zlp.html" target="_blank">OVDE </a>). Saglasan sam da moje podatke obrađujete i da mi šaljete poruke samo za one svrhe koje ću označiti ispod.',
        purchase: {
          title: 'Ponude za kupovinu vozila ',
          tooltips: 'Želim da primam prilagođene prodajne ponude za kupovinu vozila.',
          error: 'Molimo označite svoj odabir.'
        },
        afs: {
          title: 'Ponude za kupovinu postprodajnih proizvoda i usluga',
          tooltips: 'Želim da primam prilagođene prodajne ponude za kupovinu rezervnih delova, originalne dodatne opreme, servisnih usluga, ugovora o održavanju, produženoj garanciji i slično.',
          error: 'Molimo označite svoj odabir.'
        },
        personalization: {
          title: 'Personalizacija i profilisanje',
          tooltips: 'Dozvoljavam da me kontaktirate u svrhu pribavljanja dodatnih ličnih podataka (na primer pol, starost, godišnja prevezena kilometraža, geografski podaci, obrazovanje, profesija, broj članova domaćinstva, broj dece, slobodne aktivnosti, korišćenje interneta, prethodno vlasništvo  vozila, razlozi za kupovinu vozila kao i drugi slični podaci), koje ćete koristiti kako biste mi poslali  personalizovane ponude koje odgovaraju mojim željama i potrebama. Sam(a) odlučujem, koje podatke ću vam poveriti i u svakom trenutku mogu da zahtevam brisanje tih podataka.',
          error: 'Molimo označite svoj odabir.'
        }
      },
      channel: {
        title: 'Način primanja poruka',
        description: 'Dozvoljavam da me Renault Nissan Srbija d.o.o. i izabrani ovlaščeni distributer Nissan obaveštavate na izabrane načine koje ću označiti ispod.',
        email: 'E-adresa',
        sms: 'SMS',
        phone: 'Telefon',
        mail: 'Obična pošta',
        footer: 'Moja saglasnost za obaveštavanje se odnosi na ovo potraživanje i nije vezana za druge sisteme u kojima se mogu nalaziti moji lični podaci.<br><br>Svoju saglasnost mogu da otkažem u bilo kom trenutku tako što svoju odluku pisano ili usmeno saopštim ovlašćenom distributeru Nissan ili kompaniji Renault Nissan Srbija, d.o.o. na e-adresu: <a href="mailto:kontakt@nissan.rs">kontakt@nissan.rs</a>.<br><br>Za podatke, koje sam dostavio(la) rukovaocu podataka, mogu da zahtevam: ispravku podataka, brisanje podataka (osim ako je zahtev u suprotnosti sa važećim zakonodavstvom), uvid u podatke i izvor podataka kao i ograničenje upotrebe podataka. Rukovalac moje lične podatke prikuplja i obrađuje do opoziva, ili najduže 30 godina, u skladu sa odredbama zakonodavstva o zaštiti podataka o ličnosti. Vođenje, kontrola i upravljanje bazom podataka ličnosti kao i posredovanje podataka trećim licima precizno određuje Pravilnik ZLP kompanije Renault Nissan Srbija, d.o.o. i Katalog podataka o ličnosti, kojima upravlja Renault Nissan Srbija, d.o.o. Više o opštim informacijama o zaštiti ličnih podataka mogu da pročitam <a href="http://www.nissan.rs/opste-zlp.html" target="_blank">OVDE</a>. U slučaju zloupotrebe mojih podataka mogu da se obratim kompaniji Renault Nissan Srbija d.o.o. na e-adresu: <a href="mailto:zlp.nissan@nissan.rs">zlp.nissan@nissan.rs</a>.'
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/texts.js